import DeliveryOptionsProvider from '@/models/DeliveryOptionsProvider';
import IOptionHandler from './IOptionHandler';

class DoNothingOptionHandler implements IOptionHandler {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  execute(provider: DeliveryOptionsProvider, map: Map<string, unknown>): void {
    // Do nothing
  }
}

export default DoNothingOptionHandler;
